/** Tiny localStorage helpers for device-local viewer preferences (never throws). */

export function readPref<T>(key: string, fallback: T, valid?: (v: unknown) => v is T): T {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    const v = JSON.parse(raw) as unknown;
    if (valid ? valid(v) : typeof v === typeof fallback) return v as T;
  } catch {
    /* storage unavailable or corrupt */
  }
  return fallback;
}

export function writePref(key: string, value: unknown): void {
  try {
    if (value === null || value === undefined) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* quota / private mode */
  }
}

export const PREF = {
  lastSheet: (songId: string) => `kgr.viewer.sheet.${songId}`,
  lastLyrics: (songId: string) => `kgr.viewer.lyrics.${songId}`,
  allFiles: 'kgr.viewer.allFiles',
  /** 'width' = Samfellt (continuous scroll), 'page' = Heil síða (one whole page at a time) — see pageMode. */
  fit: 'kgr.viewer.fit',
  /** Landscape two-up page mode chosen (default true; only applies when wide enough) — see pageMode. */
  twoUp: 'kgr.viewer.twoUp',
  /** The one-time two-up hint (tap zones / swipes) has been shown on this device. */
  twoUpHint: 'kgr.viewer.twoUpHint',
  /** The one-time "Heil síða" hint (tap zones / swipes) has been shown on this device. */
  pageHint: 'kgr.viewer.pageHint',
  dock: 'kgr.viewer.dock',
  lyricsSize: 'kgr.viewer.lyricsSize',
  lyricsContrast: 'kgr.viewer.lyricsContrast',
  audioPos: (fileId: string) => `kgr.audio.pos.${fileId}`,
  audioRate: (songId: string) => `kgr.audio.rate.${songId}`,
  lastTrack: (songId: string) => `kgr.audio.track.${songId}`,
} as const;
